import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import landingEn from "./locales/en/landing.json";
import landingLt from "./locales/lt/landing.json";
import loginEn from "./locales/en/login.json";
import loginLt from "./locales/lt/login.json";
import registerEn from "./locales/en/register.json";
import registerLt from "./locales/lt/register.json";
import forgotPasswordEn from "./locales/en/forgotPassword.json";
import forgotPasswordLt from "./locales/lt/forgotPassword.json";
import resetPasswordEn from "./locales/en/resetPassword.json";
import resetPasswordLt from "./locales/lt/resetPassword.json";
import notFoundEn from "./locales/en/notFound.json";
import notFoundLt from "./locales/lt/notFound.json";
import settingsEn from "./locales/en/settings.json";
import settingsLt from "./locales/lt/settings.json";
import leaderboardEn from "./locales/en/leaderboard.json";
import leaderboardLt from "./locales/lt/leaderboard.json";
import shopEn from "./locales/en/shop.json";
import shopLt from "./locales/lt/shop.json";
import profileEn from "./locales/en/profile.json";
import profileLt from "./locales/lt/profile.json";
import quizEn from "./locales/en/quiz.json";
import quizLt from "./locales/lt/quiz.json";
import homeEn from "./locales/en/home.json";
import homeLt from "./locales/lt/home.json";
import commonEn from "./locales/en/common.json";
import commonLt from "./locales/lt/common.json";

export const LANG_STORAGE_KEY = "app_lang";
export type SupportedLanguage = "lt" | "en";
export type SupportedLocale = "lt-LT" | "en-US";

const normalizeLocale = (lng: string): SupportedLocale =>
  lng.toLowerCase().startsWith("en") ? "en-US" : "lt-LT";

export const getBaseLanguage = (lng?: string): SupportedLanguage =>
  normalizeLocale(lng ?? "lt-LT").split("-")[0] as SupportedLanguage;

export const getSavedLocale = (): SupportedLocale => {
  if (typeof window === "undefined") return "lt-LT";
  const savedLng = localStorage.getItem(LANG_STORAGE_KEY);
  if (!savedLng) return "lt-LT";
  return normalizeLocale(savedLng);
};

export const getLanguageTag = (lng?: string): string => {
  return normalizeLocale(lng ?? getSavedLocale());
};

const resources = {
  en: {
    landing: landingEn,
    login: loginEn,
    register: registerEn,
    forgotPassword: forgotPasswordEn,
    resetPassword: resetPasswordEn,
    notFound: notFoundEn,
    settings: settingsEn,
    leaderboard: leaderboardEn,
    shop: shopEn,
    profile: profileEn,
    quiz: quizEn,
    home: homeEn,
    common: commonEn,
  },
  lt: {
    landing: landingLt,
    login: loginLt,
    register: registerLt,
    forgotPassword: forgotPasswordLt,
    resetPassword: resetPasswordLt,
    notFound: notFoundLt,
    settings: settingsLt,
    leaderboard: leaderboardLt,
    shop: shopLt,
    profile: profileLt,
    quiz: quizLt,
    home: homeLt,
    common: commonLt,
  },
};

const initialLng = getBaseLanguage(getSavedLocale());

const syncDocumentLanguage = (lng: string) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = getBaseLanguage(lng);
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: "en",
  defaultNS: "landing",
  interpolation: {
    escapeValue: false,
  },
});

syncDocumentLanguage(initialLng);

i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(LANG_STORAGE_KEY, normalizeLocale(lng));
  }
  syncDocumentLanguage(lng);
});

export default i18n;
